import { getFromLS, saveInLS, THEME_LS_KEY } from './local-storage-api';

export function changeTheme() {
  if (document.body.classList.contains('theme-dark')) {
    document.body.classList.remove('theme-dark');
    document.body.classList.add('theme-light');
    saveInLS(THEME_LS_KEY, 'theme-light');
  } else {
    document.body.classList.remove('theme-light');
    document.body.classList.add('theme-dark');
    saveInLS(THEME_LS_KEY, 'theme-dark');
  }
}
export function initTheme() {
  const currentTheme = getFromLS(THEME_LS_KEY);

  if (currentTheme === 'theme-light') {
    document.body.classList.remove('theme-dark');
    document.body.classList.add('theme-light');
  }
}
